// src/presentation/pages/ClinicalExamination/sections/SleepQualitySection.tsx
import React from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface SleepQualitySectionProps {
  value: string;
  onChange: (value: string) => void;
}

export const SleepQualitySection: React.FC<SleepQualitySectionProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className="border-gray-200">
      <div className="pb-3">
        <p className="text-sm text-gray-500">
          {t("clinicalSections.sleepQuality.question")}
        </p>
      </div>
      <div>
        <RadioGroup
          value={value}
          onValueChange={onChange}
          className="space-y-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="excellent" id="sleep-excellent" />
            <Label
              htmlFor="sleep-excellent"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.sleepQuality.excellent")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="good" id="sleep-good" />
            <Label
              htmlFor="sleep-good"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.sleepQuality.good")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="poor" id="sleep-poor" />
            <Label
              htmlFor="sleep-poor"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.sleepQuality.poor")}
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
